import React, { useEffect, useState } from "react";
import axios from "axios";

export default function QueryLentaModal({ isOpen, onClose, queryId }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [copiadoQuery, setCopiadoQuery] = useState(false);
  const [copiadoBlocking, setCopiadoBlocking] = useState(false);

  useEffect(() => {
    if (isOpen && queryId) {
      setLoading(true);
      axios
        .get(`${process.env.REACT_APP_API}/monitoramento/queries-lentas/${queryId}`)
        .then((res) => {
          setData(res.data.data);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => setLoading(false));
    }
  }, [isOpen, queryId]);

  const copiarTexto = async (texto, tipo) => {
    try {
      await navigator.clipboard.writeText(texto);
      if (tipo === "query") {
        setCopiadoQuery(true);
        setTimeout(() => setCopiadoQuery(false), 2000);
      } else {
        setCopiadoBlocking(true);
        setTimeout(() => setCopiadoBlocking(false), 2000);
      }
    } catch (err) {
      console.error("Erro ao copiar:", err);
    }
  };

  const formatarData = (data) => {
    if (!data) return "-";
    return new Date(data).toLocaleString("pt-BR");
  };

  const formatarTempo = (segundos) => {
    if (!segundos) return "-";
    if (segundos < 60) return `${segundos} segundos`;
    if (segundos < 3600) return `${Math.floor(segundos / 60)}m ${segundos % 60}s`;
    return `${Math.floor(segundos / 3600)}h ${Math.floor((segundos % 3600) / 60)}m`;
  };

  const formatarNumero = (num) => {
    if (!num) return "-";
    return num.toLocaleString("pt-BR");
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative bg-white rounded-xl shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b">
            <h2 className="text-lg font-semibold text-gray-900">
              Detalhes da Query Lenta
            </h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Content */}
          <div className="px-6 py-4 overflow-y-auto max-h-[calc(90vh-120px)]">
            {loading ? (
              <div className="flex justify-center py-8">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-slate-800"></div>
              </div>
            ) : data ? (
              <div className="space-y-6">
                {/* Info Cards */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <div className="bg-gray-50 rounded-lg p-3">
                    <p className="text-xs text-gray-500">Data/Hora</p>
                    <p className="font-medium">{formatarData(data.dataCaptura)}</p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-3">
                    <p className="text-xs text-gray-500">Login</p>
                    <p className="font-medium">{data.loginName || "-"}</p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-3">
                    <p className="text-xs text-gray-500">Comando</p>
                    <p className="font-medium">{data.command || "-"}</p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-3">
                    <p className="text-xs text-gray-500">Status</p>
                    <p className="font-medium">{data.status || "-"}</p>
                  </div>
                </div>

                {/* Métricas */}
                <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                  <div className="bg-red-50 rounded-lg p-3">
                    <p className="text-xs text-red-600">Tempo Total</p>
                    <p className="font-semibold text-red-700">{formatarTempo(data.totalElapsedSeconds)}</p>
                  </div>
                  <div className="bg-blue-50 rounded-lg p-3">
                    <p className="text-xs text-blue-600">CPU Time</p>
                    <p className="font-medium text-blue-700">{formatarTempo(Math.floor(data.cpuTime / 1000))}</p>
                  </div>
                  <div className="bg-green-50 rounded-lg p-3">
                    <p className="text-xs text-green-600">Reads</p>
                    <p className="font-medium text-green-700">{formatarNumero(data.reads)}</p>
                  </div>
                  <div className="bg-amber-50 rounded-lg p-3">
                    <p className="text-xs text-amber-600">Writes</p>
                    <p className="font-medium text-amber-700">{formatarNumero(data.writes)}</p>
                  </div>
                  <div className="bg-purple-50 rounded-lg p-3">
                    <p className="text-xs text-purple-600">Session ID</p>
                    <p className="font-medium text-purple-700">{data.sessionId || "-"}</p>
                  </div>
                </div>

                {/* Wait Type e Blocking */}
                {(data.waitType || data.blockingSessionId) && (
                  <div className="grid grid-cols-2 gap-4">
                    {data.waitType && (
                      <div className="bg-orange-50 rounded-lg p-3">
                        <p className="text-xs text-orange-600">Wait Type</p>
                        <p className="font-medium text-orange-700">{data.waitType}</p>
                      </div>
                    )}
                    {data.blockingSessionId && data.blockingSessionId > 0 && (
                      <div className="bg-red-50 rounded-lg p-3">
                        <p className="text-xs text-red-600">Bloqueada por Session</p>
                        <p className="font-semibold text-red-700">{data.blockingSessionId}</p>
                      </div>
                    )}
                  </div>
                )}

                {/* Query Text */}
                <div>
                  <div className="flex items-center justify-between mb-2">
                    <p className="text-sm font-medium text-gray-700">Query Executada</p>
                    <button
                      onClick={() => copiarTexto(data.queryText, "query")}
                      className="text-xs text-blue-600 hover:text-blue-800 flex items-center gap-1"
                    >
                      {copiadoQuery ? (
                        <>
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                          </svg>
                          Copiado!
                        </>
                      ) : (
                        <>
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                          </svg>
                          Copiar
                        </>
                      )}
                    </button>
                  </div>
                  <pre className="bg-gray-900 text-gray-100 p-4 rounded-lg text-sm overflow-x-auto max-h-64 whitespace-pre-wrap">
                    {data.queryText || "Query não disponível"}
                  </pre>
                </div>

                {/* Blocking Query Text */}
                {data.blockingQueryText && (
                  <div>
                    <div className="flex items-center justify-between mb-2">
                      <p className="text-sm font-medium text-red-700">Query Bloqueadora</p>
                      <button
                        onClick={() => copiarTexto(data.blockingQueryText, "blocking")}
                        className="text-xs text-blue-600 hover:text-blue-800 flex items-center gap-1"
                      >
                        {copiadoBlocking ? "Copiado!" : "Copiar"}
                      </button>
                    </div>
                    <pre className="bg-red-900 text-red-100 p-4 rounded-lg text-sm overflow-x-auto max-h-64 whitespace-pre-wrap">
                      {data.blockingQueryText}
                    </pre>
                  </div>
                )}
              </div>
            ) : (
              <p className="text-center text-gray-500 py-8">Erro ao carregar dados</p>
            )}
          </div>

          {/* Footer */}
          <div className="flex justify-end px-6 py-4 border-t bg-gray-50">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm rounded-md bg-slate-800 text-white hover:bg-slate-700"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}